/**
 * @file: 单选
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as SelectToolkit from './toolkit';
import * as CaptureRule from './captureRule';
import ShortCutKey from '../shortcutkey/index';
import SelectStore from './store/index';
import CodiSystem from '../../codiSystem/index';
import NextTick from '../../utils/nextTick';
import Message from './message';
import { StageEvent } from '../../message/index';

/**
 * 根据事件源和查询规则来捕获鼠标点击选中的cube
 */
function single(ev): void {
    let $target: JQuery<EventTarget> = $(ev.target);
    let cubeId: CubeId = CaptureRule.queryCubeIdBeHit($target);
    let selectedCube: CubeNode = CubeTree.findByCubeId(cubeId);

    if (!selectedCube || !SelectToolkit.canSelect(selectedCube)) {
        return;
    }

    SelectToolkit.addOne(cubeId);
    Message.panelSelectAsync();
}

export {
    single
}
